///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';
import { CustomerDTO } from '../../../generated/shared-types.model';

export const getCustomersList = createAction('[Accordion] Get Customers List', props<{ filter: string; baseUrl: string }>());

export const setCustomersList = createAction('[Accordion] Set Customers List', props<{ customersList: CustomerDTO[] }>());

export const getSelectedCustomerInfo = createAction('[Accordion] Set Select Current Customer', props<{ selectedCustomerId: number }>());

export const setSelectedCustomerInfo = createAction('[Accordion] Navigate To Selected Customer', props<{ customer: CustomerDTO }>());

//we need this temporary action while user-activity and project-eng do not have ngrx-implementation
export const noOpAction = createAction('[Accordion] No Operation Action');
